export default __webpack_public_path__ + "static/media/mid-autum-logo.8e8351d6.webp";